<script setup>
import {ref, computed, watch} from "vue"
import axios from "axios"
// import {SelectOption, Spin, message } from "ant-design-vue";
import Json from '@/services/json'
import SaveInfo from "@/components/Base/SaveInfo.vue";

import BlockSelector from "@/components/Blocks/BlockSelector.vue";
import BlockRenderer from "@/components/Blocks/BlockRenderer.vue";

const competition = ref({
  competitionData: {
    blocks: [],
    is_catalog_publish: false
  }
});

function addBlock(object) {
  competition.value.competitionData.blocks.push(object)
  saveData();
}

function removeBlock(index) {
  competition.value.competitionData.blocks.splice(index, 1);
  saveData();
}

function moveBlockUp(index) {
  if (index > 0) {
    const blocks = competition.value.competitionData.blocks;
    const temp = blocks[index];
    blocks[index] = blocks[index - 1];
    blocks[index - 1] = temp;
    saveData();
  }
}

function moveBlockDown(index) {
  const blocks = competition.value.competitionData.blocks;
  if (index < blocks.length - 1) {
    const temp = blocks[index];
    blocks[index] = blocks[index + 1];
    blocks[index + 1] = temp;
    saveData();
  }
}

function handleOk(index, object) {
  competition.value.competitionData.blocks[index] = object;
  saveData();
}

function saveBlockData(index, object) {
  competition.value.competitionData.blocks[index].data = object;
  saveData();
}


// const users_options = ref([]);
// const selected_item = ref('');
// const selected_item_id = ref('');
// const fetching = ref(false);
// const loading = ref(false);
// const catalogUsers = ref([]);


const isDataUpdating = ref(false);
const isLoading = ref(false);


const competitionId = computed(() => {
  return window.competitionId;
})

// const userIds = computed(() => {
//   return competition.value?.competitionData?.catalog_data.map((item) => {
//     return item.catalog_user;
//   });
// })
//
// function getUserDataById(id) {
//   return catalogUsers.value.find((el) => {
//     return el.id === id
//   })
// }

async function getData() {
  isLoading.value = true;
  try {
    const response = await axios.get('/api/competitions/' + competitionId.value);
    delete response.data.categories;
    delete response.data.avatar;
    response.data.user = '/api/users/' + response.data.user.id;
    response.data.competitionData = Json.handle_json_field(response.data.competitionData, competition.value.competitionData);
    competition.value = response.data;

  } catch (error) {
    console.log(error);
  }
  //getUsersByIds();

  isLoading.value = false;
}

getData();

// async function getUsersByIds() {
//   if (userIds.value) {
//     const response = await axios.post('/getUsersByIds', {
//       'ids': userIds.value
//     })
//     catalogUsers.value = response.data;
//   }
// }
//

async function saveData() {
  isDataUpdating.value = true;
  await axios.patch('/api/competitions/' + competitionId.value, competition.value, {
    headers: {
      'Content-Type': "application/merge-patch+json"
    }
  }).catch((event) => {
    alert(event.response.data['hydra:description']);
  })
  isDataUpdating.value = false;
}

async function publishCatalog(state) {
  competition.value.competitionData.is_catalog_publish = state;
  saveData();
}

// async function fetchUsers(value) {
//   const self = this;
//   clearTimeout(this.delayTimeout);
//
//   this.delayTimeout = setTimeout(function () {
//     fetching.value = true;
//     if (value.length > 0) {
//       axios.get('/user/getAllCatalogUsers/' + value).then((data) => {
//         users_options.value = data.data.map((item) => {
//           return {
//             id: item.id,
//             label: item.fio,
//             email: item.email,
//             roles: item.user_roles,
//             value: '/api/users/' + item.id,
//             showContactInfo: item.showContactInfo,
//             public_account: item.public_account
//           }
//         });
//       })
//     }
//     fetching.value = false;
//   }, 1000); // set the delay time in milliseconds here
// }
//
// async function changeUser(value) {
//   const item = users_options.value.find((el) => {
//     return el.value === value
//   });
//   if (!item.public_account) {
//     alert('Пользователя нельзя добавить т.к. он не открыл свои персональные данные');
//     selected_item.value = null;
//     selected_item_id.value = null;
//     return;
//   }
//   selected_item.value = item.label;
//   selected_item_id.value = item.id;
// }
//
// async function addCatalogUser(index) {
//   if (selected_item_id.value) {
//     competition.value.competitionData.catalog_data[index].catalog_user = selected_item_id.value;
//
//     selected_item.value = null;
//     selected_item_id.value = null;
//     await saveData();
//     getData();
//   }
// }
//
// async function deleteCatalogUser(id) {
//   loading.value = true;
//   await axios.get('/competition/delete_catalog_user/' + id + '/' + competitionId.value);
//   getData();
// }
//

//
// function addCatalogRazdel() {
//   competition.value.competitionData.catalog_data.push({
//     catalog_description: '',
//     catalog_information: '',
//     catalog_user: undefined,
//   })
// }
//
//

//
// function saveExpertData(data, index) {
//   if (!competition.value.competitionData?.catalog_data?.[index]?.custom_users) {
// 		competition.value.competitionData.catalog_data[index].custom_users = [];
//   }
//   competition.value.competitionData.catalog_data[index].custom_users.push(data);
//   saveData();
// }
//
// function updateExpertData(data, catalogIndex, userIndex) {
//   if (competition.value?.competitionData?.catalog_data?.[catalogIndex]?.custom_users) {
//     competition.value.competitionData.catalog_data[catalogIndex].custom_users[userIndex] = data;
//     saveData();
//   } else {
//     console.error('Структура данных не соответствует ожидаемой');
//   }
// }
//
// function saveSlidesData(data, index) {
//   if (!competition.value.competitionData?.catalog_data?.[index]?.slides) {
//     competition.value.competitionData.catalog_data[index].slides = [];
//   }
//   competition.value.competitionData.catalog_data[index].slides.push(data);
//   saveData();
// }
//
// function remove_expert_landing(expert, index) {
//   if (confirm('Вы уверены, что хотите удалить этого эксперта?')) {
//     if (competition.value?.competitionData?.catalog_data?.[index]?.custom_users) {
//       competition.value.competitionData.catalog_data[index].custom_users =
//         competition.value.competitionData.catalog_data[index].custom_users.filter(u => u !== expert);
//       saveData();
//     } else {
//       console.error('Структура данных не соответствует ожидаемой');
//     }
//   }
// }
//
// const customUsersForIndex = computed(() => (index) => {
//   return competition.value?.competitionData?.catalog_data?.[index]?.custom_users || [];
// });
//
// const slidesForIndex = computed(() => (index) => {
//   return competition.value?.competitionData?.catalog_data?.[index]?.slides || [];
// });
//
// function handleDeleteSlide(item, index) {
//   if (competition.value?.competitionData?.catalog_data?.[index]?.slides) {
//     competition.value.competitionData.catalog_data[index].slides =
//       competition.value.competitionData.catalog_data[index].slides.filter(slide => slide !== item);
//     saveData();
//   }
// }
//
// function handleDeleteUser(item, index) {
//   if (competition.value?.competitionData?.catalog_data?.[index]?.custom_users) {
//     competition.value.competitionData.catalog_data[index].custom_users =
//       competition.value.competitionData.catalog_data[index].custom_users.filter(user => user !== item);
//     saveData();
//   }
// }
//




</script>

<template>
  <SaveInfo
      :isDataUpdating="isDataUpdating"
  ></SaveInfo>
  <div class="content-tab">

    <div style="padding: 30px">
	    <h3>Блоки</h3>
	    <div style="margin-bottom: 20px;">
        <BlockSelector @save-block="addBlock" :length="competition.competitionData.blocks.length"/>
	    </div>
	    <BlockRenderer
			    :blocks="competition.competitionData.blocks"
			    :competitionId="competitionId"
			    @add-block="addBlock"
			    @handle-ok="handleOk"
			    @save-block-data="saveBlockData"
			    @move-block-down="moveBlockDown"
			    @move-block-up="moveBlockUp"
			    @remove-block="removeBlock"
	    />
    </div>
  </div>
</template>


<style scoped>


.field:deep .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
    height: 100%;
}

.razdel_block {
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 10px;
}

.razdel_block:not(:first-child) {
    margin-top: 15px;
}

.field:deep(.catalog_image) {
    max-width: 500px;
}
</style>